<template>
    <div>
        <div class="common-header">
            <div class="common-header-right">
                <div class="common-header-block">
                    信息等级：
                    <el-select
                            style="width: 100px"
                            v-model="level">
                        <el-option
                                v-for="item in levelOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="common-header-block">
                    数据类型：
                    <el-select
                            style="width: 150px"
                            v-model="simulatorCondition">
                        <el-option
                                v-for="item in simulatorConditionOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="common-header-block">
                    <el-input
                            placeholder="输入玩家ID"
                            v-model="searchVal">
                        <template slot="prepend">玩家ID</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-checkbox
                            v-model="imeiCondition"
                            :true-label="1"
                            :false-label="0"
                            label="IMEI" border/>
                </div>
                <div class="common-header-block">
                    <el-checkbox
                            v-model="ipCondition"
                            :true-label="1"
                            :false-label="0"
                            label="IP" border/>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">搜索</el-button>
                    <el-button type="success" @click="exportFunc">导出</el-button>
                </div>
            </div>
        </div>

        <div class="common-table">
            <el-table v-loading="loading" :data="list" height="100%">
                <el-table-column label="编号" align="center" type="index"/>
                <el-table-column label="用户号" align="center" prop="userId"/>
                <el-table-column label="用户昵称" align="center" prop="nickName"/>
                <el-table-column label="IMEI" align="center" prop="imeiData"/>
                <el-table-column label="IP" align="center">
                    <template slot-scope="scope">
                        <template v-for="(item,index) of scope.row.ipData">
                            {{index===0?'':','}}{{item}}
                        </template>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>
<script>
    import {mapMutations, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                searchVal: '',
                imeiCondition: 0,
                ipCondition: 0,
                simulatorCondition: '2',
                simulatorConditionOptions: [
                    {label: '全部', value: '2'},
                    {label: '真机数据', value: '0'},
                    {label: '模拟器数据', value: '1'},
                ],
                level: '1',
                levelOptions: [
                    {label: '一级', value: '1'},
                    {label: '二级', value: '2'}
                ],
                userRelevance: {// 账号关联
                    secondDatas: [],
                    thirdDatas: [],
                }
            }
        },
        computed: {
            list() {
                if (this.level === '1') {
                    return this.userRelevance.secondDatas
                } else {
                    return this.userRelevance.thirdDatas
                }
            }
        },
        methods: {
            ...mapMutations('other', ['setStateDownloadConfig']),
            ...mapActions('dataManage', ['getUserRelevance']),
            parameterCalibration() {
                if (!this.searchVal) {
                    this.$message.error('请输入玩家ID');
                    return false
                }
                return true
            },
            getList() {
                if (!this.parameterCalibration()) return;
                this.loading = true;
                let params = {
                    randomId: this.searchVal,
                    imeiCondition: this.imeiCondition,
                    ipCondition: this.ipCondition,
                    simulatorCondition: this.simulatorCondition,
                };
                this.getUserRelevance(params).then(res => {
                    this.userRelevance = res.data;
                    this.loading = false;
                })
            },
            exportFunc() {
                if (!this.parameterCalibration()) return;
                this.setStateDownloadConfig({
                    action: '/data/manage/user/relevance/export',
                    info: [
                        {name: 'imeiCondition', value: this.imeiCondition},
                        {name: 'ipCondition', value: this.ipCondition},
                        {name: 'level', value: this.level},
                        {name: 'randomId', value: this.searchVal},
                        {name: 'simulatorCondition', value: this.simulatorCondition},
                    ]
                });
            }
        }
    }
</script>